












import { defineComponent, PropType } from "@vue/composition-api";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "MoreProfileItem",
  components: { BaseAvatar },
  props: {
    user: { type: Object as PropType<User | UserPublicData>, required: true },
  },
  setup(props, { root }) {
    const handleClick = () => {
      root.$router.push(getProfileUrl(props.user));
    };
    return {
      handleClick,
    };
  },
});
